import CreateBillingGroup from '../components/templates/create-billing-group';

export const CreateBillingGroupContainer = () => {
  return <CreateBillingGroup />;
};
